import '@fontsource/plus-jakarta-sans/700-italic.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import { BrowserRouter } from 'react-router-dom'; // ADDED
import { ClerkProvider } from '@clerk/clerk-react';

import { LogProvider } from './contexts/logContext';

import App from './App.jsx';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

createRoot(document.getElementById('root')).render(
    // <StrictMode>
    <LogProvider>
        <BrowserRouter>
            <ClerkProvider publishableKey={publishableKey} signUpForceRedirectUrl="/welcome" signInForceRedirectUrl="/dashboard">
                <App />
            </ClerkProvider>
        </BrowserRouter>{' '}
    </LogProvider>,
    // </StrictMode>
);
